import React, { FC, useState } from 'react';

import { AtsType, IntegrationType } from 'src/generated/mloop-graphql';

import { GemIntegration, useIntegrationDelete } from 'src/hooks/api/integration';
import { getAtsService } from 'src/hooks/atsService';

import { DisconectAtsDialog } from '../Dialogs/DisconnectAtsDialog';
import GemDialog from '../Dialogs/GemDialog';
import IntegrationCard from '../IntegrationCard';

import { ConnectAtsButton } from './ConnectAtsButton';

export interface Props {
  gem?: GemIntegration;
  disabled?: boolean;
  onConnect?: () => void;
  onRemove?: () => void;
}

const GemCard: FC<Props> = ({ gem, disabled = false, onConnect, onRemove }) => {
  const [isDialogOpen, setDialogOpen] = useState<boolean>(false);
  const [openRemoveDialog, setOpenRemoveDialog] = useState<boolean>(false);

  const deleteGem = useIntegrationDelete(IntegrationType.GemApiKey);

  const atsService = getAtsService(AtsType.Gem);

  return (
    <>
      <IntegrationCard
        dataTestId="gem-card-integration-card"
        logo={atsService.logoUrl}
        name="Gem"
        onConnect={gem ? undefined : () => setDialogOpen(true)}
        onManageSetup={gem ? () => setDialogOpen(true) : undefined}
        onRemove={gem ? () => setOpenRemoveDialog(true) : undefined}
        disabled={disabled}
        disableManageSetup={disabled}
        connectButton={
          <ConnectAtsButton
            dataTestId="gem-card-integration-card"
            handleConnect={() => setDialogOpen(true)}
            disabled={disabled}
          />
        }
      />
      {isDialogOpen && (
        <GemDialog
          disabled={disabled}
          apiKey={gem?.api_key || ''}
          onClose={() => setDialogOpen(false)}
          onSave={() => {
            setDialogOpen(false);
            onConnect?.();
          }}
        />
      )}
      {openRemoveDialog && (
        <DisconectAtsDialog
          integrationName={atsService.name || ''}
          onClose={() => {
            setOpenRemoveDialog(false);
          }}
          onRemove={() => {
            setOpenRemoveDialog(false);
            deleteGem.mutate(undefined, {
              onSuccess: () => {
                onRemove?.();
              },
            });
          }}
        />
      )}
    </>
  );
};

export default GemCard;
